import { AsyncValidatorFn, ValidatorFn } from "@angular/forms";
import { Observable } from "rxjs";

export class DynamicValidation {
    validator!: ValidatorFn;
    asyncValidator!: AsyncValidatorFn;
    isAsync?: boolean;
    isCustom?: boolean;
    type: 'required' | 'pattern' | 'minlength' | 'maxlength';
    customType?: string;
    errorMessage: string;
    errorMessageObserver?: Observable<string>;
    validatorObserver?: Observable<ValidatorFn>;

    constructor(source: Partial<DynamicValidation>) {
        this.type = 'required';
        this.errorMessage = '';
        Object.assign(this, source);

        this.errorMessageObserver?.subscribe(value => {
            this.errorMessage = value;
        });

        this.validatorObserver?.subscribe(value => {
            this.validator = value;
        });
    }
}